import type { StyleRule } from '@archipro-design/aria';
import { boxClassName } from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { breadcrumbClassName } from '@fluentui/react-northstar';

export const Container: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.bodyBackground,
    padding: pxArrayToRem([32, 0, 60, 0]),
    [theme.screen.tablet]: {
        paddingTop: 0,
        padding: pxArrayToRem([0, 50]),
    },
    [theme.screen.max.tablet]: {
        overflowX: 'hidden',
        touchAction: 'pan-y',
    },
});

export const ContainerInner: StyleRule = ({ theme }) => ({
    width: '100%',
    maxWidth: '100vw',
    minWidth: 'unset',
    paddingTop: 0,
    [theme.screen.tablet]: {
        minWidth: pxToRem(1024),
        maxWidth: pxToRem(1920),
    },
});

export const BottomNav: StyleRule = ({ theme }) => ({
    [`&.${breadcrumbClassName}`]: {
        flexWrap: 'wrap',
        height: 'unset',
        padding: pxArrayToRem([16, 18, 28, 18]),
        ['& .' + captionClassName]: {
            whiteSpace: 'nowrap',
            color: theme.siteVariables.colors.grey['300'],
        },
        [`& .${boxClassName}`]: {
            margin: pxArrayToRem([0, 5, 4, 0]),
            '&:first-child': {
                '& a': {
                    marginLeft: 0,
                    color: theme.siteVariables.colors.grey['300'],
                },
            },
        },
    },
});
